import { ExternalLink, Lightbulb } from "lucide-react";

/** The line a supporter repeats: one achievement, quantified and attributed. */
export const DidYouKnow = ({ fact, testId = "did-you-know" }) =>
  fact ? (
    <section className="border-l-2 border-ochre bg-[#0b0b0b] p-6 md:p-8" data-testid={testId}>
      <div className="flex items-center gap-2">
        <Lightbulb size={14} className="text-ochre" />
        <p className="overline text-ochre">Did you know</p>
      </div>
      <h3 className="mt-4 max-w-3xl font-display text-xl font-bold uppercase leading-tight text-white md:text-3xl">
        {fact.headline}
      </h3>
      <p className="mt-5 max-w-3xl text-sm leading-relaxed text-zinc-300 md:text-base">{fact.body}</p>

      <div
        className={`mt-7 grid gap-px bg-zinc-800 sm:grid-cols-2 [&>*]:min-w-0 ${
          fact.numbers.length % 4 === 0 ? "lg:grid-cols-4" : "lg:grid-cols-3"
        }`}
      >
        {fact.numbers.map((n, i) => (
          <div key={n.label} className="bg-black p-5" data-testid={`${testId}-number-${i}`}>
            <p className="font-display text-2xl font-bold leading-none text-ochre md:text-3xl">{n.value}</p>
            <p className="mono mt-3 text-[0.55rem] uppercase leading-relaxed tracking-[0.14em] text-zinc-400">
              {n.label}
            </p>
          </div>
        ))}
      </div>

      {fact.video ? (
        <div className="mt-7 max-w-3xl" data-testid={`${testId}-video`}>
          <div className="relative w-full border border-zinc-800" style={{ paddingBottom: "56.25%" }}>
            <iframe
              src={`https://www.youtube.com/embed/${fact.video.id}`}
              title={fact.video.title}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              loading="lazy"
              className="absolute inset-0 h-full w-full"
            />
          </div>
          <p className="mono mt-3 text-[0.55rem] uppercase tracking-[0.16em] text-zinc-500">
            {fact.video.title}
          </p>
        </div>
      ) : null}

      {fact.source ? (
        <a
          href={fact.source.url}
          target="_blank"
          rel="noreferrer"
          data-testid={`${testId}-source`}
          className="mono mt-6 inline-flex items-center gap-2 text-[0.55rem] uppercase tracking-[0.16em] text-zinc-500 transition-colors hover:text-ochre"
        >
          {fact.source.label} <ExternalLink size={11} />
        </a>
      ) : (
        <p className="mono mt-6 text-[0.55rem] uppercase tracking-[0.16em] text-zinc-500" data-testid={`${testId}-note`}>
          {fact.note || "First-hand account"}
        </p>
      )}
    </section>
  ) : null;
